import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { ImageSlot } from './ImageSlot';
import { SectionHeading } from './SectionHeading';
type BonusesSectionProps = {
  bonusCovers: string[];
};
export function BonusesSection({
  bonusCovers
}: BonusesSectionProps) {
  return <section aria-labelledby="bonuses-title" className="bg-white py-12 md:py-20" data-id="element-40" data-mp="qsrsubwn3qnd">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-41" data-mp="14t2ortct3vfe">
        <SectionHeading id="bonuses-title" eyebrow={bonuses.eyebrow} title={bonuses.title} sub={bonuses.sub} data-id="element-42" data-mp="14rhpxrjglqbq" />

        <ul className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2" data-id="element-43" data-mp="1eje2g7malizh">
          {bonuses.items.map((b, i) => {
          const featured = i === 0;
          return <li key={b.label} className={`flex flex-col overflow-hidden rounded-xl border bg-white sm:flex-row sm:items-center sm:gap-6 sm:p-5 ${featured ? 'border-2 border-sun md:col-span-2 md:gap-8 md:p-7' : 'border-hair'}`} data-id="element-44" data-mp="19l2s7vs356gq" data-mpi={i}>
                {/* Fixed square box: the cover is absolutely positioned so it never changes the layout when it loads
                    (otherwise the scroll to #offer lands short on mobile). */}
                <div className={`relative aspect-square w-full shrink-0 overflow-hidden bg-mist sm:rounded-lg ${featured ? 'sm:w-40 md:w-48' : 'sm:w-36'}`} data-id="element-45" data-mp="2np5ieutpm2y">
                  <ImageSlot url={bonusCovers[i]} alt={`Copertina: ${b.title}`} slotName={`bonusCovers[${i}]`} fit="contain" className="absolute inset-0 p-3 sm:p-0" data-id="element-46" data-mp="gl58fgdwuxpy" />
                </div>
                <div className="min-w-0 p-5 sm:p-0" data-id="element-47" data-mp="qb6xobi02m6g">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-48" data-mp="qaovyzckjfr5">
                    <span className="inline-block rounded-md bg-sun px-2 py-1 font-display text-[11px] font-black tracking-[0.08em] text-ink" data-id="element-49" data-mp="vb2u9podbbbz">{b.label}</span>
                    <span className="inline-block rounded-md bg-leaf-soft px-2 py-1 font-display text-[11px] font-black tracking-[0.06em] text-leaf-ink" data-id="element-50" data-mp="107091rjzg9mn">
                      {bonuses.valueLabel} {b.value} — {bonuses.free}
                    </span>
                  </div>
                  <p className="mt-3 text-[15px] font-semibold text-coral-ink" data-id="element-51" data-mp="kclie01vv5p3">{b.hook}</p>
                  <h3 className={`mt-1 font-display font-extrabold uppercase leading-snug tracking-tight text-brand ${featured ? 'text-[18px] md:text-[24px]' : 'text-[17px]'}`} data-id="element-52" data-mp="fiqyowma2qq0">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-[16px] leading-relaxed text-ink/75" data-id="element-53" data-mp="1394sarkigxmp">{b.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 flex max-w-[560px] items-center justify-center gap-2.5 rounded-xl bg-leaf-soft px-4 py-4 text-center font-display text-[17px] font-black text-leaf-ink md:text-[20px]" data-id="element-54" data-mp="352atc1zgu7ci">
          <GiftIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-55" data-mp="1fl6ymmi8v0da" />
          {bonuses.totalNote}
        </p>
      </div>
    </section>;
}